"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceLogMessageViewer = class InvoiceLogMessageViewer extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoiceId;
    onInvoice_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoiceId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_invoice', { parameters: { id: this.invoiceId } });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_1040167445267876_options;
    dataMembers = ['item', 'ux', 'b_7315092382398562_modalBindings', 'b_1040167445267876_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "full-screen",
                },
                b_1040167445267876_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.item ? this.item.invoice_number : '-',
                icon: this.$config.invoice.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3342_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3342 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3342_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3341 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3342,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3341],
        });
        const act_2248226175642056_closeModal_3344 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_3343 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_3344,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3343],
        });
        return {
            act_7315092382398562_closeModal_3342,
            evh_7315092382398562_close_3341,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_3344,
            evh_2248226175642056_close_3343,
            evh_2248226175642056_close,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLogMessageViewer.prototype, "invoiceId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoiceId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLogMessageViewer.prototype, "onInvoice_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], InvoiceLogMessageViewer.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLogMessageViewer.prototype, "onSize", null);
InvoiceLogMessageViewer = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceLogMessageViewer);
exports.default = InvoiceLogMessageViewer;
vue_property_decorator_1.Vue.component("InvoiceLogMessageViewer", InvoiceLogMessageViewer);
